// extracted by mini-css-extract-plugin
export default {"item":"FaqAccordion_item__8fzzz","question":"FaqAccordion_question__ga-uY","icon":"FaqAccordion_icon__YIKOX","answer":"FaqAccordion_answer__-PUQS"};